import React from "react";
import { Link } from "react-router-dom";
import { Home, Search, ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* 404 Number */}
        <div className="relative">
          <h1 className="text-[150px] font-bold text-red-600 leading-none">
            404
          </h1>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-3">
          ไม่พบหน้าที่ต้องการ
        </h2>
        <p className="text-gray-500 mb-8">
          หน้าที่คุณกำลังมองหาอาจถูกย้ายหรือลบไปแล้ว
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/home"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-all"
          >
            <Home size={20} />
            กลับหน้าหลัก
          </Link>
          <Link
            to="/all-products"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all"
          >
            <Search size={20} />
            ค้นหาสินค้า
          </Link>
        </div>

        {/* Go Back Link */}
        <button
          onClick={() => window.history.back()}
          className="mt-8 inline-flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <ArrowLeft size={16} />
          ย้อนกลับ
        </button>
      </div>
    </div>
  );
};

export default NotFound;
